export default __webpack_public_path__ + "static/media/ami1.f7e794dc.jpg";